import React, { Component } from 'react';
import { asyncComponent } from 'react-async-component';
import PropTypes from 'prop-types';

const Bing = asyncComponent({
    resolve: () => import('./Bing'),
});

export default class BingWrapper extends Component {
    render() {
        return(
            <div>
                <Bing config={this.props.config} reportEvent={this.props.reportEvent(this.props.config.id)} />
            </div>
        );
    }
}

BingWrapper.propTypes = {
    config: PropTypes.object.isRequired,
};
